import IsochroneHandler from "../../map/IsochroneHandler";
import MapHandler from "../../map/MapHandler";
import IsochroneWheel from "../gui/IsochroneWheel";

export default class IsochronePainter {
  #isochroneHandler;
  #gui;

  #timer!: number;
  #oldX;
  #oldAngle;

  constructor(gui: IsochroneWheel, isochroneHandler: IsochroneHandler) {
    this.#isochroneHandler = isochroneHandler;
    this.#gui = gui; //new IsochroneWheel();
    this.#oldX = -1;
    this.#oldAngle = -1;
  }

  onAddObject(evt: any, maphandler: MapHandler) {
    this.#isochroneHandler.setMap(maphandler.getMap());
    this.#isochroneHandler.drawIsochrone(
      evt.symbolId,
      evt.xPos,
      evt.yPos,
      evt.angle
    );
    this.#gui.addWheel(evt.xPos, evt.yPos, evt.angle);
  }

  onUpdateObject(evt: any) {
    if (this.#oldX !== evt.xPos || this.#oldAngle !== evt.angle) {
      this.#oldX = evt.xPos;
      this.#oldAngle = evt.angle;

      const timerCallBack = () => {
        this.#gui.updateWheel(evt.xPos, evt.yPos, evt.angle);
        this.#isochroneHandler.drawIsochrone(
          evt.symbolId,
          evt.xPos,
          evt.yPos,
          evt.angle
        );
      };
      this.resetTimer(timerCallBack);
    }
    this.#gui.updateWheel(evt.xPos, evt.yPos, evt.angle);
  }

  onRemoveObject(evt: any) {
    clearTimeout(this.#timer);
    this.#isochroneHandler.removeIsochrone("isochrone" + evt.symbolId);
    this.#isochroneHandler.removePopup(evt.symbolId);
    this.#gui.removeWheel();
  }

  resetTimer(timerCallBack: Function) {
    clearTimeout(this.#timer);
    this.#timer = setTimeout(timerCallBack, 500);
  }
}
